import { styled } from "@mui/material/styles";
import { StepRow } from "../StepRow";
import type { LoadingStep } from "../../../../hooks/useLoadingSteps";

interface LoadingStageProps {
  steps: LoadingStep[];
  activeStepIndex: number;
  subMessage: string;
}

const StepList = styled("div")({
  width: "100%",
  maxWidth: 460,
  textAlign: "left",
});

export function LoadingStage({ steps, activeStepIndex, subMessage }: LoadingStageProps) {
  return (
    <StepList>
      {steps.map((step, i) => {
        const status = i < activeStepIndex ? "done" : i === activeStepIndex ? "active" : "pending";
        return (
          <StepRow
            key={step.label}
            label={step.label}
            subMessage={i === activeStepIndex ? subMessage : ""}
            status={status}
          />
        );
      })}
    </StepList>
  );
}
